/// <amd-module name="typeahead/core/message/SuggestionShownMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {IEssSuggestionResult} from "typeahead/core/Suggestion";

export class SuggestionShownMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.suggestion_shown";
    }

    constructor(
      private readonly suggestions: IEssSuggestionResult[],
      private readonly elementValue: string,
      private readonly activeESSTests: string,
      private readonly lob: string,
      private readonly renderTime: number,
      private readonly domElementId: string,
      private readonly numberOfPrefixPopCandidates: string,
      private readonly totalSuggestion: string,
    ) {}

    public getTopic(): string {
        return SuggestionShownMessage.getTopic();
    }

    public getDomElementId(): string {
        return this.domElementId;
    }

    public getShownSuggestions(): IEssSuggestionResult[] {
        return this.suggestions;
    }

    public getElementValue(): string {
        return this.elementValue;
    }

    public getLob(): string {
        return this.lob;
    }

    public getActiveESSTests(): string {
        return this.activeESSTests;
    }

    public getRenderTime(): number {
        return this.renderTime;
    }

    public getNumberOfPrefixPopCandidates(): string {
        return this.numberOfPrefixPopCandidates;
    }

    public getTotalSuggestion(): string {
        return this.totalSuggestion;
    }
}
